import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  style: {"font-size":"1.5rem"},
  class: "fas fa-user-circle"
}


export default /*#__PURE__*/_defineComponent({
  props: {
    picture: null
  },
  setup(__props: any) {

const props = __props as {
	picture?: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["avatar avatar-sm rounded-circle", { 'no-background': !props.picture }])
  }, [
    (props.picture)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          alt: "Image placeholder",
          src: props.picture
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("i", _hoisted_2))
  ], 2))
}
}

})